module.exports = __webpack_public_path__ + "img/img29.2b4b6b6b.svg";